'use strict';

/*eslint-disable-next-line no-undef */
__webpack_public_path__ = assetsUrl;

module.exports = payload => {
  const modulePromises = [];

  if (payload.dealWidgetV2) {
    modulePromises.push(
      import(
        /* webpackChunkName: "deal_cards" */ '../../../../modules/deal_widget_v2/frontend/index'
      )
    );
  } else if (payload.clientDealWidgets) {
    modulePromises.push(
      import(/* webpackChunkName: "widgets" */ './loaders/widgets')
    );
  }

  if (payload.sharing) {
    modulePromises.push(
      import(/* webpackChunkName: "facebook" */ './loaders/facebook')
    );
  }

  return modulePromises;
};
